import React, { lazy, useLayoutEffect, useState } from 'react';
import './App.scss';
import history from './utils/browserHistory';
import { Navigate, Route, Router, Routes } from 'react-router-dom';
import PageStartLoader from './views/loaders/PageStartLoader';
import { useDefineHeaderToken } from './utils/useDefineHeaderToken';
import './utils/setupAxios';
import axios from 'axios';
import TalentResetPassword from './views/login/TalentResetPassword';
import TalentLayout from './views/talentLayout/talentLayout';
import { WorkspaceSurface } from './views/components/workspaceTheme/WorkspaceTheme';
import { mcpEnabled } from './utils/mcp';
import { customerPortalEnabled } from './utils/customerPortal';
import { DocumentTitle } from './hooks/usePageTitle';
const CustomerPortal = lazy(() => import('./views/master/CustomerPortal'));
const OAuthConsent = lazy(() => import('./views/oauth/Consent'));
const Login = lazy(() => import('./views/login/Login'));
const DefaultLayout = lazy(() => import('./views/defaultLayut/DefaultLayout'));
// Dev-only Talent page design previews; the constant-false branch drops the chunk from production builds.
const TalentDesignPreview = process.env.NODE_ENV === 'development'
  ? lazy(() => import('./views/designPreview/talent/TalentDesignPreview'))
  : null;


// The app itself always follows the real browser history, even while a report pop-up points the shared `history` at its own.
const appHistory = history.browser;

function App() {

  const [state, setState] = useState({
    action: appHistory.action,
    location: appHistory.location
  });
  useDefineHeaderToken(axios)

  useLayoutEffect(() => appHistory.listen(setState), []);

  return (
    <div className='App'>
      <Router navigator={appHistory} location={state.location} navigationType={state.action} basename={'/'}>
        <DocumentTitle />
        <React.Suspense fallback={<PageStartLoader />}>
          <Routes>
            <Route name="Talent login" path="/talent/login" element={<Navigate replace to="/login" />}/>
            <Route name="Talent Reset Password" path="/talent/reset-password" element={<WorkspaceSurface><TalentResetPassword loginPath="/login" portalLabel="COMS" /></WorkspaceSurface>}/>
            <Route
              name="Staff Reset Password"
              path="/reset-password"
              element={<WorkspaceSurface><TalentResetPassword userType="auto" portalLabel="COMS" loginPath="/login" /></WorkspaceSurface>}
            />
            {customerPortalEnabled()
              ? <Route path='/customer/*' element={<CustomerPortal/>}/>
              : <Route path='/customer/*' element={<Navigate replace to='/login' />}/>}
            {mcpEnabled() && <Route path="/oauth/consent" name="OAuth consent" element={<WorkspaceSurface><OAuthConsent /></WorkspaceSurface>} />}
            {TalentDesignPreview && <Route path="/design-preview/:variant" element={<TalentDesignPreview />} />}
            <Route name="Talent home" path="/talent/*" element={<TalentLayout/>} />
            <Route exact path="/" name="COMS Login Page" element={<WorkspaceSurface><Login /></WorkspaceSurface>} />
            <Route exact path="/login" name="Login Page" element={<WorkspaceSurface><Login /></WorkspaceSurface>} />
            <Route path="/*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </React.Suspense>
      </Router>
    </div>
  );
}

export default App;
